import * as React from "react";
import { Form, Formik } from "formik";
import isEqual from "lodash/isEqual";
import styled from "styled-components";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, FormSubmit, PageHeader, Spinner } from "components/common";
import DisabledDefaultProviderAlert from "ai-management/model-providers/DisabledDefaultProviderAlert";
import AIManagementPageNavigation from "ai-management/AIManagementPageNavigation";
import useConfiguredModelProviders from "ai-management/model-providers/hooks/useConfiguredModelProviders";
import useFeatureModels from "ai-management/feature-models/hooks/useFeatureModels";
import useUpdateFeatureModels from "ai-management/feature-models/hooks/useUpdateFeatureModels";
import FeatureModelGroup from "./FeatureModelGroup";
const Actions = styled(FormSubmit)`
  display: flex;
  justify-content: flex-end;
`;
export const initialValuesFor = (features) => Object.fromEntries(
  features.map(({ feature_id, setting }) => {
    var _a, _b;
    return [
      feature_id,
      { provider: (_a = setting == null ? void 0 : setting.provider) != null ? _a : null, model: (_b = setting == null ? void 0 : setting.model_id) != null ? _b : null }
    ];
  })
);
export const changedSettingsFor = (values, initialValues) => Object.entries(values).filter(([featureId, value]) => !isEqual(value, initialValues[featureId])).map(([featureId, { provider, model }]) => ({
  feature_id: featureId,
  setting: {
    provider,
    model_id: model
  }
}));
const FeatureModelsPage = () => {
  const { data: features, isLoading: featuresLoading } = useFeatureModels();
  const { data: providers, isLoading: providersLoading } = useConfiguredModelProviders();
  const { updateFeatureModels } = useUpdateFeatureModels();
  const initialValues = initialValuesFor(features);
  const groups = Object.values(
    Object.fromEntries(
      features.map((feature) => [
        feature.group_id,
        {
          id: feature.group_id,
          name: feature.group_display_name,
          features: features.filter(({ group_id }) => group_id === feature.group_id)
        }
      ])
    )
  );
  const onSubmit = (values, { resetForm }) => updateFeatureModels(changedSettingsFor(values, initialValues)).then(() => resetForm({ values }));
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Feature Models" }, /* @__PURE__ */ React.createElement(AIManagementPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Feature Models" }, /* @__PURE__ */ React.createElement("span", null, "Choose the provider and model each AI feature uses. Features without an explicit assignment use the configured defaults.")), /* @__PURE__ */ React.createElement(DisabledDefaultProviderAlert, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, featuresLoading || providersLoading ? /* @__PURE__ */ React.createElement(Spinner, { text: "Loading feature models..." }) : /* @__PURE__ */ React.createElement(Formik, { initialValues, enableReinitialize: true, onSubmit }, ({ dirty, isSubmitting, resetForm }) => /* @__PURE__ */ React.createElement(Form, null, groups.map((group) => /* @__PURE__ */ React.createElement(
    FeatureModelGroup,
    {
      key: group.id,
      name: group.name,
      features: group.features,
      providers
    }
  )), /* @__PURE__ */ React.createElement(
    Actions,
    {
      isAsyncSubmit: true,
      submitButtonText: "Save changes",
      submitLoadingText: "Saving changes...",
      isSubmitting,
      disabledSubmit: !dirty,
      onCancel: resetForm,
      disabledCancel: !dirty
    }
  ))))));
};
export default FeatureModelsPage;
